import { MagnifyingGlass } from '@phosphor-icons/react';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <section
      data-testid="not-found"
      className="mx-auto my-16 flex max-w-[560px] flex-col items-start gap-[18px] rounded-xl border border-line bg-surface p-9"
    >
      <span className="grid h-[52px] w-[52px] place-items-center rounded-xl bg-chip text-accent">
        <MagnifyingGlass size={26} />
      </span>
      <span className="rounded-sm bg-bg2 px-[9px] py-[3px] text-[11px] font-semibold tracking-[.06em] text-muted uppercase">
        404
      </span>
      <div className="flex flex-col gap-2">
        <h1 className="m-0 font-heading text-2xl leading-[1.2] font-semibold tracking-[-.015em]">
          {t('panel:states.notFound.title')}
        </h1>
        <p className="m-0 text-[15px] leading-[1.6] text-muted">
          {t('panel:states.notFound.description')}
        </p>
      </div>
      <Link
        to="/"
        className="inline-flex min-h-[42px] items-center rounded-md bg-btn px-[18px] text-sm font-semibold text-btn-fg hover:bg-btn-h hover:text-btn-fg"
      >
        {t('panel:states.notFound.backHome')}
      </Link>
    </section>
  );
}

export function ForbiddenState() {
  const { t } = useTranslation();
  return (
    <section
      data-testid="forbidden"
      className="flex max-w-[560px] flex-col gap-2 rounded-xl border border-line bg-surface p-9"
    >
      <h1 className="m-0 font-heading text-2xl font-semibold">{t('panel:states.error.title')}</h1>
      <p className="m-0 text-[15px] text-muted">{t('panel:states.error.forbidden')}</p>
    </section>
  );
}
